import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-cycle
import { useFetch } from '../../../services/transports';
import { subscriptionPackage } from '../../../api/managementUsers';
import { languages } from '../../../constants';
import { LabeledSelect } from '..';

export const SubscriptionPackageDropdown = ({
  label, id, onChange, withAsterisks, disabled, value, multiple,
  subscriptionTypeId, stakeholderTypeId, setValueAsObject }) => {
  const { i18n, t } = useTranslation();

  const [ options, setOptions ] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [ { data }, fetchSubscriptionPackageDropdown ] = useFetch(
    subscriptionPackage,
    useCallback(response => {
      const container = response?.data?.container;

      return container;
    }, [])
  );

  useEffect(() => {
    const params = {};
    if (subscriptionTypeId !== undefined && subscriptionTypeId !== null) {
      params.SubscriptionTypeId = subscriptionTypeId;
    }
    if (stakeholderTypeId !== undefined && stakeholderTypeId !== null) {
      params.StakeholderTypeId = stakeholderTypeId;
    }
    fetchSubscriptionPackageDropdown(Object.keys(params).length > 0 ? params : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ subscriptionTypeId, stakeholderTypeId ]);

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const mappedOptions = data.map(i => ({
        value: i.id,
        text: i18n.language === languages.EN ? `${i.nameEn}` : `${i.nameAr}`,
        item: i
      }));
      setOptions(mappedOptions);
    } else {
      setOptions([]);
    }
  }, [ data, i18n.language ]);

  const getDisplayValue = () => {
    if (!setValueAsObject) {
      return value;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      const foundOption = options.find(opt => opt.item?.id === value || opt.value === value);

      return foundOption ? foundOption.value : value;
    }
    if (value?.value) {
      return value.value;
    }

    return value;
  };

  return (
    <LabeledSelect
      data-testid={ `${id}-packages` }
      label={ label }
      id={ id }
      mode={ multiple ? 'multiple' : undefined }
      onChange={ onChange }
      showSearch={ true }
      searchDelay={ 250 }
      options={ options }
      filterOption={ false }
      withDebounceSearch={ true }
      EmptyComponent={ t('ERR.noMatched') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear
      value={ getDisplayValue() }
      setValueAsObject={ setValueAsObject }
      placeholder={ t('fields.choose') }
    />
  );
};
